import React, { useState } from 'react';

import CreatePracticeModal from '../CreatePracticeModal';
import AddButtonComponent from './AddButtonPresentational';
import { AddButtonPropsType } from './types';

export const AddButton = ({ display, month, day, handleClickButton }: AddButtonPropsType) => { //handleClickButton only works with week view
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };//handleClickButton works instead handle show in week view, othercase it is undefined
  return (
    <>
      <AddButtonComponent
        display={display}
        handleClick={handleClickButton ? handleClickButton : handleShow}
        month={month}
      />
      {handleClickButton ? null : (show && <CreatePracticeModal show={show} handleClose={handleClose} day={day} />)}
    </>
  );
};

export default AddButton;